import React, { useEffect, useState } from "reactn";
import { Table, Space, Button, Popconfirm, Row } from 'antd';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { doc, collection, getDocs, deleteDoc, query, orderBy} from 'firebase/firestore';
import { EditOutlined, CalendarOutlined, FieldTimeOutlined, DeleteOutlined, Loading3QuartersOutlined, CheckOutlined, CloseOutlined, PlusOutlined, PlaySquareOutlined, BarcodeOutlined } from "@ant-design/icons";

const Streams = (props) => {
    let [data, setData] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [loading, setLoading] = useState(false);

    let handleTableChange = async () => {
        get();
    }

    let get = async () => {
        const streamRef = collection(firebaseDb, 'stream');
        const streamQuery = query(streamRef,  orderBy("active", "desc"),orderBy("order", "asc"));
        const streamSnapshot = await getDocs(streamQuery);
        const streamList = streamSnapshot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data(),
                active: (doc.data().active ? <CheckOutlined /> : <CloseOutlined />),
                iscoderequired: (doc.data().required ? <CheckOutlined /> : <CloseOutlined />),
                isPromotion: (doc.data().questionSetId ? "Yayın" :  "Reklam/Tanıtım")
            }
        });
        setLoading(false)
        setTotalCount(streamList.length);
        setData(streamList);
    }

    useEffect(() => {
        setLoading(true)
        get();
    }, [])

    let deleteRow = async (item_id) => {
        await deleteDoc(doc(firebaseDb, "stream", item_id));
        let newData = data.filter(el => el.id !== item_id);
        setData(newData)
    }

    let columns = [
        {
            title: 'Fotograf',
            dataIndex: 'media',
            key: 'media',
            width: 150,
            render: (media, record) => {
                return (
                    <div style={{ width: '200px' }}>
                        <img src={media ? media.url : ""} style={{ width: '100%' }} />
                    </div>
                )
            }
        },
        {
            title: 'Yayın Dili',
            dataIndex: 'lang',
            key: 'lang',
            width: 50,

        },
        {
            title: 'Yayın Adı',
            dataIndex: 'name',
            key: 'name',
            width: 100,

        },
        {
            title: 'Yayın Saati',
            key: 'action',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
                <Space size="small">
                    <Link>
                        <Button className="button4" icon={<CalendarOutlined />}>
                            {record.streamStartDate.toDate().toLocaleDateString('tr-TR')}
                        </Button>
                        <Button className="button4" icon={<FieldTimeOutlined />}>
                            {record.streamStartDate.toDate().toLocaleTimeString('tr-TR')}
                        </Button>
                    </Link>
                </Space>
            ),
        },
        {
            title: 'Yarışma Saati',
            key: 'action',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
                <Space size="small">
                    <Link className="link">
                        <Button className="button4" icon={<CalendarOutlined />}>
                            {record.competitionStartDate.toDate().toLocaleDateString('tr-TR')}
                        </Button>
                        <Button className="button4" icon={<FieldTimeOutlined />}>
                            {record.competitionStartDate.toDate().toLocaleTimeString('tr-TR')}
                        </Button>
                    </Link>
                </Space>
            ),
        },
        {
            title: 'Aktif',
            dataIndex: 'active',
            key: 'active',
            width: 50,
        },
        {
            title: 'Sıra',
            dataIndex: 'order',
            key: 'order',
            width: 50,
        },
        {
            title: 'Tip',
            dataIndex: 'isPromotion',
            key: 'isPromotion',
            width: 50,
            render: (text, record) => (
                <Space size="small">
                    <Link className="link">
                        <Button className="button4">
                            {record.isPromotion}
                        </Button>
                    </Link>
                </Space>
            ),
        },
        {
            title: 'İşlemler',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 50,
            render: (text, record) => (
                <Row className="gap-8" size="small">
                    <Link to={"/streams/edit/" + record.id}>
                        <Button className="button-consultant" icon={<EditOutlined />}>Düzenle</Button>
                    </Link>
                    <Popconfirm
                        onConfirm={() => deleteRow(record.id)} title="Silmeyi Onaylıyor musunuz?"
                        okText="Onayla" cancelText="Vazgeç">
                        <Button type="danger" className="button4" icon={<DeleteOutlined />}>
                            Sil
                        </Button>
                    </Popconfirm>
                    <Link to={"/streams/control/" + record.id}>
                        <Button className="button-consultant" icon={<PlaySquareOutlined />}>Canlı Yayın Kontrol</Button>
                    </Link>
                    {record.required &&
                        <Link to={"/streams/codes/" + record.id}>
                            <Button className="button-consultant" icon={<BarcodeOutlined />}>Katılım Kodları</Button>
                        </Link>
                    }
                </Row>
            ),
        },
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Yayınlar"} </h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/streams/add">
                        <Button type="light" className="button4" icon={<PlusOutlined />} size="large">Yayın Ekle</Button>
                    </Link>
                </div>
            </div>
            <div className="table-wrap">
                <Table dataSource={data} columns={columns} loading={{ spinning: loading, indicator: <Loading3QuartersOutlined spin />, size: "large" }}
                    onChange={handleTableChange}
                    pagination={{
                        total: totalCount
                    }}
                />
            </div>
        </div>
    );
};

export default Streams;
